import React, { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import TableHeader from "../Table/TableHeader";
import TableBody from "../Table/TableBody";
import { callButtonGeneral } from "../../DataApi/generalApis/callButtonGeneral";
import { useSession } from "../../authentications/SessionContext";
import { searchReadGeneral } from "../../DataApi/generalApis/searchReadGeneral";
import { enqueueSnackbar } from "notistack";
import useFormikSubmitButton from "../../CustomHooks/useFormikSubmitButton";
import ButtonSpinLoader from "../ButtonLoader/ButtonSpinLoader";
import { primaryColor } from "../../utilities/colors";
const TableContainer = styled.div`
  width: 100%;
  background-color: #fff;
  padding: 13px;
  min-height: 200px;
`;

const Button = styled.button`
  border: none;
  border-radius: 10px;
  color: #fff;
  background-color: ${(props) => (props.active ? primaryColor.primary : "silver")};
  background-color: ;
  padding: 5px 10px;
`;
function OrderInvoices({
  selectedOrder,
  selectedSaleOrderDetail,
  fetchData,
  invoices,
  setInvoices,
}) {
  const { sessionInfo } = useSession();
  const { company_id, context } = sessionInfo;

  const {
    setIsSubmitting: setIsInvoiceLoading,
    isSubmitting: isInvoiceLoading,
  } = useFormikSubmitButton();
  const [isLoadingData, setIsLoadingData] = useState(true);

  const getInvoiceList = async (ids = selectedSaleOrderDetail?.invoice_ids) => {
    const model = "account.move";
    const fields = [
      "name",
      "partner_id",
      "invoice_source_email",
      "invoice_partner_display_name",
      "invoice_date",
      "invoice_date_due",
      "invoice_origin",
      "payment_reference",
      "ref",
      "invoice_user_id",
      "team_id",
      "activity_ids",
      "activity_exception_decoration",
      "activity_exception_icon",
      "activity_state",
      "activity_summary",
      "activity_type_id",
      "activity_type_icon",
      "company_id",
      "amount_untaxed_signed",
      "amount_tax_signed",
      "amount_total_signed",
      "amount_residual_signed",
      "currency_id",
      "company_currency_id",
      "state",
      "payment_state",
      "move_type",
    ];

    let readResponse;
    readResponse = await searchReadGeneral({
      company_id,
      domain: selectedSaleOrderDetail?.invoice_ids ? [["id", "in", ids]] : [],
      context,
      fields,
      model,
    });
    setInvoices(readResponse?.result?.records || []);
    setIsLoadingData(false);
    return readResponse?.result?.records || [];
  };

  const handleCreateAndPayInvoice = async ({ method, args, index }) => {
    setIsInvoiceLoading(`${method}${index}`);
    const response = await callButtonGeneral({
      company_id,
      method,
      model: "sale.order",
      args: [args],
      context,
    });
    if (typeof response.result !== "undefined") {
      enqueueSnackbar("Invoice Created", { variant: "success" });

      const orderDetailResponse = await fetchData();

      if (response) {
        await getInvoiceList(orderDetailResponse?.invoice_ids);
      }
    } else {
      enqueueSnackbar("Somthing Went Wrong", { variant: "error" });
    }
    setIsInvoiceLoading(false);
  };
  const handleCancelInvoice = async (data, index) => {
    setIsInvoiceLoading(`button_cancel${index}`);

    await callButtonGeneral({
      company_id,
      method: "button_cancel",
      model: "account.move",
      args: [data.id],
      context: {
        ...context,

        active_model: "sale.order",
        active_id: selectedOrder,
        active_ids: [selectedOrder],
        default_move_type: "out_invoice",

        default_invoice_origin: selectedSaleOrderDetail.reference,
      },
    });
    const orderDetailResponse = await fetchData();
    await getInvoiceList(orderDetailResponse?.invoice_ids);
    setIsInvoiceLoading(false);
    return;
  };
  const hadnelResetToDraft = async (data, index) => {
    setIsInvoiceLoading(`mp_api_reverse_invoice${index}`);
    const response = await callButtonGeneral({
      company_id,
      method: "mp_api_reverse_invoice",
      model: "sale.order",
      args: [data.id],
      // context: {
      //   ...context,
      //   active_id: selectedSaleOrderDetail.id,
      //   active_ids: [selectedSaleOrderDetail.id],
      //   params: {
      //     active_id: selectedSaleOrderDetail.id,
      //     model: "account.move",
      //     view_type: "form",
      //   },
      //   default_move_type: "out_invoice",
      // },
      context,
    });
    const orderDetailResponse = await fetchData();

    await getInvoiceList(orderDetailResponse?.invoice_ids);
    setIsInvoiceLoading(false);
    return;
  };

  useEffect(() => {
    if (invoices?.length === 0) setIsLoadingData(true);
    getInvoiceList();
  }, []);
  const renderInputList = useMemo(
    () => [
      {
        title: "Refrence",
        name: "name",
      },
      {
        title: "Customer",
        name: "invoice_partner_display_name",
      },
      {
        title: "Invoice Date",
        name: "invoice_date",
      },
      {
        title: "Company",
        name: "company_id",
        handleCell: (data, item) => data?.[item.name]?.[1] || "",
      },

      {
        title: "Tax Excluded",
        name: "amount_untaxed_signed",
      },
      {
        title: "Amount Total",
        name: "amount_total_signed",
      },
      {
        title: "Status",
        name: "state",
      },
      {
        title: "Payment Status",
        name: "payment_state",
      },
      {
        title: "Action",
        name: "",
        style: { minWidth: 170 },
        handleCell: (data, item, index) => {
          return (
            <div className="d-flex gap-2">
              {data.state === "draft" ? (
                <>
                  <Button
                    onClick={() =>
                      handleCreateAndPayInvoice({
                        method: "mp_api_post_and_pay_invoice",
                        args: `${data.id}`,
                        index,
                      })
                    }
                    type="button"
                    active={true}
                    disabled={isInvoiceLoading}
                  >
                    {isInvoiceLoading === `mp_api_post_and_pay_invoice${index}`
                      ? "Loading..."
                      : "Pay"}
                  </Button>
                  <Button
                    type="button"
                    disabled={isInvoiceLoading}
                    onClick={() => handleCancelInvoice(data, index)}
                  >
                    {isInvoiceLoading === `button_cancel${index}`
                      ? "Loading..."
                      : "Cancel"}
                  </Button>
                </>
              ) : (
                <Button
                  type="button"
                  onClick={() => {
                    hadnelResetToDraft(data, index);
                  }}
                  active={true}
                  disabled={isInvoiceLoading}
                >
                  {isInvoiceLoading === `mp_api_reverse_invoice${index}`
                    ? "Loading..."
                    : "Reverse Transaction"}
                </Button>
              )}
            </div>
          );
        },
      },
    ],
    [isInvoiceLoading]
  );
  return (
    <TableContainer>
      <table className="table">
        <TableHeader tableHeaderList={renderInputList} />

        <TableBody
          tableData={invoices}
          tableBodyList={renderInputList}
          isLoadingData={isLoadingData}
          handleRowClick={(data) => {
            // setSelectedDeliveryOrder(data.id);
          }}
        />
      </table>
      {selectedSaleOrderDetail.invoice_status === "to invoice" && (
        <button
          onClick={() =>
            handleCreateAndPayInvoice({
              method: "mp_api_create_and_post_and_pay_inv",
              args: `${selectedOrder}`,
            })
          }
          disabled={isInvoiceLoading}
          style={{ border: "none", backgroundColor: "#fff", color: "red" }}
        >
          {isInvoiceLoading === "mp_api_create_and_post_and_pay_inv"
            ? "Loading..."
            : "Create and Pay Invoice"}
        </button>
      )}
    </TableContainer>
  );
}

export default OrderInvoices;
